import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const RssSocialIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  height = 30,
  width = 30,
}) => {
  return (
    <svg
      className={className}
      height={height}
      width={width}
      viewBox="-2 -1 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>RSS</title>
      <path
        fill={fill}
        d="M3.772 10.864c0 .454-.159.84-.477 1.159a1.578 1.578 0 0 1-1.159.477c-.454 0-.84-.16-1.159-.477a1.578 1.578 0 0 1-.477-1.16c0-.454.16-.84.477-1.158a1.578 1.578 0 0 1 1.16-.478c.454 0 .84.16 1.158.478.318.318.477.704.477 1.159Zm4.363 1.048a.516.516 0 0 1-.144.409.502.502 0 0 1-.401.179H6.44a.524.524 0 0 1-.367-.14.519.519 0 0 1-.17-.354A5.3 5.3 0 0 0 4.33 8.669 5.3 5.3 0 0 0 .994 7.097a.519.519 0 0 1-.353-.17A.524.524 0 0 1 .5 6.56V5.41c0-.166.06-.3.179-.401a.497.497 0 0 1 .366-.145h.043a7.64 7.64 0 0 1 2.608.686c.83.383 1.565.899 2.207 1.547a7.536 7.536 0 0 1 1.546 2.207c.384.83.613 1.699.686 2.608Zm4.364.017a.493.493 0 0 1-.154.4.504.504 0 0 1-.392.171h-1.218a.532.532 0 0 1-.38-.15.51.51 0 0 1-.166-.361 9.53 9.53 0 0 0-.86-3.482 9.796 9.796 0 0 0-1.973-2.864A9.795 9.795 0 0 0 4.492 3.67a9.65 9.65 0 0 0-3.48-.869.51.51 0 0 1-.363-.166.522.522 0 0 1-.149-.37v-1.22C.5.886.557.755.67.653A.51.51 0 0 1 1.045.5h.026c1.488.074 2.913.415 4.274 1.023 1.36.608 2.569 1.443 3.625 2.505a11.948 11.948 0 0 1 2.506 3.627 11.83 11.83 0 0 1 1.022 4.274Z"
      />
    </svg>
  );
};

export default RssSocialIcon;
